import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import store from './store';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles'; // Correct import

const root = ReactDOM.createRoot(document.getElementById('zc-vendor-root'));


root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
